import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import { useRecoilState, useRecoilValue } from "recoil";

import SelectMenuItem from "../Customer/Component/SelectMenuItem";
import { useUpdateCustomerMutation } from "../../../Service/customers";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerList } from "../../../store/async-actions/digitalmarketing/dashboard";
import { useGetDashboardCustomersQuery } from "../../../Service/dashboard";
import { ServiceChosen } from "../Customer/Utils/CustomerLabelInput";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import { FaBullseye } from "react-icons/fa";
import PermissionCheck from "../../../Component/PermissionCheck";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import { useDeleteMedicineMasterMutation } from "../../../Service/MedicineMaster";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import { medicineUpdateSelector } from "../../../State/selectors";
import { useUpdateCustomerJourneyMasterMutation } from "../../../Service/CustomerJourneyMaster";
const useStyles = makeStyles({
  Mimo: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FB6A6A",
      backgroundColor: "#FFF7F7",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Fertility: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BB54A",
      backgroundColor: "#F7FFF8",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Action: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  status: {
    width: 148,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
});
interface props {
  customer_list: any;
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  stableSort: any;
  state: any;
  setstates: any;
  setMedicine: any;
  refetch: any;
  setUpdated: any;
  updated: any;
  medicines: any;
  deleted: any;
  setDeleted: any;
  pagination: any;
}
function TableList({
  customer_list,
  getComparator,
  order,
  updated,
  orderBy,
  handleClick,
  handleChange,
  state,
  deleted,
  setDeleted,
  setstates,
  setMedicine,
  setUpdated,
  medicines,
  refetch,
  pagination,

  stableSort,
}: props) {
  const classes = useStyles();
  const [deleteMedicine] = useDeleteMedicineMasterMutation();

  const [ishover, sethover] = useState(null);
  const handleMouseEnter = (index) => {
    sethover(index);
  };
  const { open, message, openSnackBar, type } = useSnackbar();

  const dispatch = useDispatch<any>();
  const [medicineUpdate, setMedicineUpdate] = useRecoilState(
    medicineUpdateSelector
  );
  // console.log("medi",medicineUpdate);

  const DashboardStatus = [
    {
      id: 1,
      name: "Active",
      descriptions: "Active",
      others: "#ff0000",
      mode: "journey_status",
      status: "1",
      comments: null,
      createdBy: null,
      updatedBy: null,
      createdAt: "2024-02-06T11:57:40.000Z",
      updatedAt: "2024-02-06T11:57:40.000Z",
    },
    {
      id: 2,
      name: "Inactive",
      descriptions: "Inactive",
      others: "#00ff27",
      mode: "journey_status",
      status: "0",
      comments: null,
      createdBy: null,
      updatedBy: null,
      createdAt: "2024-02-06T11:57:40.000Z",
      updatedAt: "2024-02-06T11:57:40.000Z",
    },
  ];
  let status = DashboardStatus.map((item) => ({
    label: item.name,
    value: item.status,
  }));
  const [updateCustomerJourney, { isLoading: updateLoading }] =
    useUpdateCustomerJourneyMasterMutation();

  const handleSelectChange = (event, stage) => {
    const { name, value } = event.target;
    if (stage.id) {
      var { activeStatus, steps } = stage;
      // console.log(activeStatus);
      // console.log(value);
      activeStatus = value;

      const extractedData = { activeStatus };
      // console.log(extractedData);
      // console.log(stage.id);

      updateCustomerJourney({
        id: stage.id,
        ...extractedData,
      });
      setUpdated(true);
      refetch();
      setTimeout(() => {
        setUpdated(FaBullseye);
      }, 1000);
    }
  };
  const {
    open: open1,
    message: message1,
    openDelete,
    deleteId,
  } = useDeleteBox();
  const Delete = async (bool) => {
    if (bool) {
      try {
        await deleteMedicine(deleteId).unwrap();
        openSnackBar("Deleted successfully");
        setDeleted(true);
      } catch (err: any) {
        openSnackBar(err.data.error, "error");
      }
    }
    openDelete("Are you sure you want to delete this User?", false, null);
  };


  const onClick = (medicine) => {
    // console.log(medicine);

    setMedicine(medicine);
    setUpdated(false);

    setstates(!state);
  };

  return (
    <>
      <AlertDialog open={open1} message={message1} deleteBranches={Delete} />

      {stableSort(medicines, getComparator(order, orderBy))?.map((a, i) => {
        return (
          <TableRow role="checkbox" tabIndex={-1} key={i + 1}>
            <TableCell align="left">{(pagination - 1) * 10 + i + 1}</TableCell>

            <TableCell align="left">{a.customerJourneyName}</TableCell>
            {/* <TableCell align="left">{a.description}</TableCell> */}
            {/* <TableCell align="left"><p style={{
  borderRadius: "20px",marginBottom:"0",
  color:a.activeStatus?"#439F77":"#EB3068",
  textAlign:"center",
  backgroundColor: a.activeStatus? "#EFF8FF":"#FFF2F6",padding:"6px 10px"}}
><span style={{width:"5px",height:"5px",padding:"0 7px",borderRadius:"50%", backgroundColor:a.activeStatus?"#439F77":"#EB3068",}}></span>	&nbsp;&nbsp;{a.activeStatus?"Active":"Inactive"}</p></TableCell> */}

            <TableCell align="left">
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                <SelectMenuItem
                  styles={
                    a.activeStatus === 1
                      ? "select select-option-active"
                      : "select select-option-inactive"
                  }
                  name="status"
                  option={status}
                  view={false}
                  value={a.activeStatus}
                  onChange={(e) => handleSelectChange(e, a)}
                />
              </FormControl>
            </TableCell>

            {/* <TableCell align="left">
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <SelectMenuItem 
                styles={"select"} 
                name="stat" 
                option={status} 
          
                value={getValueByLabel(a.customerStatus)} 
                onChange={(e) => handleSelectChange(e,a)} 
                />
               
              </FormControl>
            </TableCell> */}
            {/* <TableCell align="left">
              <span>{a.last_contacted}</span>
              <br></br>
              <small>{a.time}</small>
            </TableCell> */}
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursur me-2"
                onClick={() => {
                  onClick(a);
                  setMedicineUpdate(true);
                }}
              />
              <img
                src={dele}
                alt="delete"
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this customer journey?",
                    true,
                    a.id
                  )
                }
                className="delete-icon cursur action-icon"
              />
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
